//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postRefreshToken,
} from "../../../helpers/fakebackend_helper";
import { getLoggedinUser } from "../../../helpers/api_helper";
import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';
import { message } from "antd";

export const loginUser = (user, history) => async (dispatch) => {

  try {
    let response = postFakeLogin({
        username: user.email,
        password: user.password,
      });

    var data = await response;

    console.log('TOKENRESP', data)

    if (data) {
      localStorage.setItem("authUser", JSON.stringify(data));
      dispatch(loginSuccess(data));
      history("/dashboard");
    }
  } catch (error) {
    dispatch(apiError({data: error?.response?.data?.detail || error?.message}));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const setRefreshInterval = () => async (dispatch) => {

  const user = getLoggedinUser()
  if (!user){
    console.log('LOGGED OUT')
    return
  }

  const diffToExpiery = (new Date(user['expiery']) - new Date())/1000;
  const refreshTimeout = (diffToExpiery < 0 ? 0 : diffToExpiery - 10) * 1000

  setTimeout(() => {
    dispatch(refreshJWT());
  }, refreshTimeout)
}

export const refreshJWT = () => async (dispatch) => {

  const user = getLoggedinUser()
  if (!user){
    console.log('LOGGED OUT')
    return
  }

  try {
    console.log('Refreshing JWT', user)
    let response = postRefreshToken({
        refresh: user.refresh,
      });

    var data = await response;

    if (data) {
      const authData = JSON.parse(localStorage.getItem("authUser") || "{}");
      authData['access'] = data['access']
      authData['expiery'] = data['expiery']
      localStorage.setItem("authUser", JSON.stringify(authData));
      dispatch(setRefreshInterval())
      dispatch(loginSuccess(data));
    }
  } catch (error) {
    dispatch(apiError({data: error?.response?.data?.detail || error?.message}));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
    //   response = postSocialLogin(data);
    // }

    const socialdata = await response;
    if (socialdata) {
      localStorage.setItem("authUser", JSON.stringify(socialdata));
      dispatch(loginSuccess(socialdata));
      history('/dashboard');
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
